import { DATE_FILTER_ELEMENT_SYSNAME, REPORTS_FILTER_DATE_TIME_CURRENT_MONTH, REPORTS_FILTER_DATE_TIME_CURRENT_WEEK, REPORTS_FILTER_DATE_TIME_DATE_RANGE, REPORTS_FILTER_DATE_TIME_LAST_FOUR_WEEKS, REPORTS_FILTER_DATE_TIME_LAST_MONTH, REPORTS_FILTER_DATE_TIME_LAST_SIX_MONTHS, REPORTS_FILTER_DATE_TIME_LAST_THREE_DAYS, REPORTS_FILTER_DATE_TIME_LAST_TWO_WEEKS, REPORTS_FILTER_DATE_TIME_LAST_WEEK, REPORTS_FILTER_DATE_TIME_LAST_YEAR, REPORTS_FILTER_DATE_TIME_SPECIFIC_DATE, REPORTS_FILTER_DATE_TIME_TODAY, REPORTS_FILTER_DATE_TIME_YESTERDAY, TIME_FILTER_ELEMENT_SYSNAME, FILTER_INACTIVE_DAYS_30, FILTER_INACTIVE_DAYS_60, FILTER_INACTIVE_DAYS_90, FILTER_INACTIVE_DAYS_180, FILTER_INACTIVE_DAYS_365, INACTIVE_FOR_FILTER_ELEMENT_SYSNAME } from "../../constants/element-type";
import { DEF_PG_SIZE_WIZARD } from "../../constants/maximum-page-size";
import {HOURS_WORKED, REPORT_STILL_ON_SITE, REPORTS_CARDS_NOT_USED } from "../../constants/menu-types";
import { TranslationKeys } from "../../contexts/TranslationKeys";
import { Translator } from "../../contexts/translator";
import { ListData } from "../../models/ListData";
import { ListQuery } from "../../models/ListQuery";
import { TableColumn } from "../../models/table/TableColumn";
import { FilterModel } from "./FilterModel";

export const NameOnlyColumn: TableColumn[] = [
    {
        id: 0,
        heading: "Name",
        accessor: "name",
        isNumeric: false,
        active: true,
        translationKey: "name",
    }
];

export const getFilterTypes = (translate: Translator, menuId?: string): Promise<ListData> => {
    let rows = [
        {
            id: 1,
            name: translate.byKey(TranslationKeys.dateFilter),
            nameOriginal: translate.byKey(TranslationKeys.dateFilter),
            elementSysname: DATE_FILTER_ELEMENT_SYSNAME
        }
    ]

    if (menuId === HOURS_WORKED) {
        rows.push(
            ...[
                {
                    id: 3,
                    name: translate.byKey(TranslationKeys.company),
                    nameOriginal: translate.byKey(TranslationKeys.company),
                    elementSysname: "company"
                },
                {
                    id: 4,
                    name: translate.byKey(TranslationKeys.department),
                    nameOriginal: translate.byKey(TranslationKeys.department),
                    elementSysname: "department"
                },
                {
                    id: 5,
                    name: translate.byKey(TranslationKeys.category),
                    nameOriginal: translate.byKey(TranslationKeys.category),
                    elementSysname: "profileName"
                },
                {
                    id: 6,
                    name: translate.byKey(TranslationKeys.site),
                    nameOriginal: translate.byKey(TranslationKeys.site),
                    elementSysname: "site"
                },
                {
                    id: 7,
                    name: translate.byKey(TranslationKeys.displayName),
                    nameOriginal: translate.byKey(TranslationKeys.displayName),
                    elementSysname: "displayName"
                }
            ]
        )
    }
    else if (menuId === REPORT_STILL_ON_SITE) {
        rows.push(
            {
                id: 2,
                name: translate.byKey(TranslationKeys.timeFilter),
                nameOriginal: translate.byKey(TranslationKeys.timeFilter),
                elementSysname: TIME_FILTER_ELEMENT_SYSNAME
            }
        )
    }
    else if (menuId === REPORTS_CARDS_NOT_USED) {
        rows = [
            {
                id: 1,
                name: translate.byKey(TranslationKeys.inactiveFor),
                nameOriginal: translate.byKey(TranslationKeys.inactiveFor),
                elementSysname: INACTIVE_FOR_FILTER_ELEMENT_SYSNAME
            }
        ];
    }

    return new Promise((resolve, reject) => {
        return resolve({
            rows: rows,
            pagination: { maxPageSize: DEF_PG_SIZE_WIZARD, pageNumber: 1, totalCount: rows.length, totalPages: 1 }
        });
    })
}

export const getDateCategory = (translate: Translator, filter?: FilterModel, listParameters?: ListQuery): Promise<ListData> => {
    const rows = [
        {
            id: 1,
            name: translate.byKey(TranslationKeys.specificDate),
            nameOriginal: translate.byKey(TranslationKeys.specificDate),
            elementSysname: REPORTS_FILTER_DATE_TIME_SPECIFIC_DATE,
        },
        {
            id: 2,
            name: translate.byKey(TranslationKeys.dateRange),
            nameOriginal: translate.byKey(TranslationKeys.dateRange),
            elementSysname: REPORTS_FILTER_DATE_TIME_DATE_RANGE,
        },
        {
            id: 3,
            name: translate.byKey(TranslationKeys.currentMonth),
            nameOriginal: translate.byKey(TranslationKeys.currentMonth),
            elementSysname: REPORTS_FILTER_DATE_TIME_CURRENT_MONTH,
        },
        {
            id: 4,
            name: translate.byKey(TranslationKeys.currentWeek),
            nameOriginal: translate.byKey(TranslationKeys.currentWeek),
            elementSysname: REPORTS_FILTER_DATE_TIME_CURRENT_WEEK,
        },
        {
            id: 5,
            name: translate.byKey(TranslationKeys.lastTwoWeeks),
            nameOriginal: translate.byKey(TranslationKeys.lastTwoWeeks),
            elementSysname: REPORTS_FILTER_DATE_TIME_LAST_TWO_WEEKS,
        },
        {
            id: 6,
            name: translate.byKey(TranslationKeys.lastThreeDays),
            nameOriginal: translate.byKey(TranslationKeys.lastThreeDays),
            elementSysname: REPORTS_FILTER_DATE_TIME_LAST_THREE_DAYS,
        },
        {
            id: 7,
            name: translate.byKey(TranslationKeys.lastFourWeeks),
            nameOriginal: translate.byKey(TranslationKeys.lastFourWeeks),
            elementSysname: REPORTS_FILTER_DATE_TIME_LAST_FOUR_WEEKS,
        },
        {
            id: 8,
            name: translate.byKey(TranslationKeys.lastSixMonths),
            nameOriginal: translate.byKey(TranslationKeys.lastSixMonths),
            elementSysname: REPORTS_FILTER_DATE_TIME_LAST_SIX_MONTHS,
        },
        {
            id: 9,
            name: translate.byKey(TranslationKeys.lastMonth),
            nameOriginal: translate.byKey(TranslationKeys.lastMonth),
            elementSysname: REPORTS_FILTER_DATE_TIME_LAST_MONTH,
        },
        {
            id: 10,
            name: translate.byKey(TranslationKeys.lastWeek),
            nameOriginal: translate.byKey(TranslationKeys.lastWeek),
            elementSysname: REPORTS_FILTER_DATE_TIME_LAST_WEEK,
        },
        {
            id: 11,
            name: translate.byKey(TranslationKeys.lastYear),
            nameOriginal: translate.byKey(TranslationKeys.lastYear),
            elementSysname: REPORTS_FILTER_DATE_TIME_LAST_YEAR,
        },
        {
            id: 12,
            name: translate.byKey(TranslationKeys.today),
            nameOriginal: translate.byKey(TranslationKeys.today),
            elementSysname: REPORTS_FILTER_DATE_TIME_TODAY,
        },
        {
            id: 13,
            name: translate.byKey(TranslationKeys.yesterday),
            nameOriginal: translate.byKey(TranslationKeys.yesterday),
            elementSysname: REPORTS_FILTER_DATE_TIME_YESTERDAY,
        }
    ]

    return new Promise((resolve, reject) => {
        let filteredRows = rows.filter((row) => {
                if (filter?.include) {
                    return filter.elementSysname.includes(row.elementSysname);
                }
                else if (!filter?.include) {
                    return !filter?.elementSysname.includes(row.elementSysname);
                }

                return true;
        });

        if (listParameters?.searchTerm?.value) {
            const searchValue = listParameters.searchTerm.value.toLowerCase();
            filteredRows = filteredRows.filter(row => 
                row.name.toLowerCase().includes(searchValue) || 
                row.nameOriginal.toLowerCase().includes(searchValue) ||
                row.elementSysname.toLowerCase().includes(searchValue)
            );
        }

        const totalCount = filteredRows.length;
        const pageSize = listParameters?.pageSize ?? DEF_PG_SIZE_WIZARD;
        const totalPages = Math.ceil(totalCount / pageSize);
        const pageNumber = listParameters?.goToPage ?? 1;
        const startIndex = (pageNumber - 1) * pageSize;
        const endIndex = pageNumber * pageSize;
        
        return resolve({
            rows: filteredRows.slice(startIndex, endIndex),
            pagination: { maxPageSize: pageSize, pageNumber: pageNumber, totalCount: totalCount, totalPages: totalPages }
        });
    })
}

export const getInactiveForCategory = (translate: Translator, filter?: FilterModel, listParameters?: ListQuery): Promise<ListData> => {
    const rows = [
        {
            id: 1,
            name: translate.byKey(TranslationKeys.inactiveFor30Days),
            nameOriginal: translate.byKey(TranslationKeys.inactiveFor30Days),
            elementSysname: FILTER_INACTIVE_DAYS_30,
        },
        {
            id: 2,
            name: translate.byKey(TranslationKeys.inactiveFor60Days),
            nameOriginal: translate.byKey(TranslationKeys.inactiveFor60Days),
            elementSysname: FILTER_INACTIVE_DAYS_60,
        },
        {
            id: 3,
            name: translate.byKey(TranslationKeys.inactiveFor90Days),
            nameOriginal: translate.byKey(TranslationKeys.inactiveFor90Days),
            elementSysname: FILTER_INACTIVE_DAYS_90,
        },
        {
            id: 4,
            name: translate.byKey(TranslationKeys.inactiveFor180Days),
            nameOriginal: translate.byKey(TranslationKeys.inactiveFor180Days),
            elementSysname: FILTER_INACTIVE_DAYS_180,
        },
        {
            id: 5,
            name: translate.byKey(TranslationKeys.inactiveFor365Days),
            nameOriginal: translate.byKey(TranslationKeys.inactiveFor365Days),
            elementSysname: FILTER_INACTIVE_DAYS_365,
        }
    ]

    return new Promise((resolve, reject) => {
        let filteredRows = rows.filter((row) => {
            if (filter?.include) {
                return filter.elementSysname.includes(row.elementSysname);
            }
            else if (!filter?.include) {
                return !filter?.elementSysname.includes(row.elementSysname);
            }

            return true;
        });

        if (listParameters?.searchTerm?.value) {
            const searchValue = listParameters.searchTerm.value.toLowerCase();
            filteredRows = filteredRows.filter(row =>
                row.name.toLowerCase().includes(searchValue) ||
                row.nameOriginal.toLowerCase().includes(searchValue) ||
                row.elementSysname.toLowerCase().includes(searchValue)
            );
        }

        const totalCount = filteredRows.length;
        const pageSize = listParameters?.pageSize ?? DEF_PG_SIZE_WIZARD;
        const totalPages = Math.ceil(totalCount / pageSize);
        const pageNumber = listParameters?.goToPage ?? 1;
        const startIndex = (pageNumber - 1) * pageSize;
        const endIndex = pageNumber * pageSize;

        return resolve({
            rows: filteredRows.slice(startIndex, endIndex),
            pagination: { maxPageSize: pageSize, pageNumber: pageNumber, totalCount: totalCount, totalPages: totalPages }
        });
    })
}

export const getFilterableEntities = (translate: Translator): Promise<ListData> => {
    const rows = [
        {
            id: 1,
            name: translate.byKey(TranslationKeys.controller),
            nameOriginal: translate.byKey(TranslationKeys.controller),
            settingDataName: "deviceImprox"
        }
    ]

    return new Promise((resolve, reject) => {
        return resolve({
            rows: rows,
            pagination: { maxPageSize: DEF_PG_SIZE_WIZARD, pageNumber: 1, totalCount: rows.length, totalPages: 1 }
        });
    })
}
